import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

// Ultimate Workaround for React 19 + Radix UI bugs
const originalSetAttribute = Element.prototype.setAttribute;
Element.prototype.setAttribute = function (name, value) {
  if (name === 'aria-hidden' && value === 'true') {
    return; // Prevent crash when active element is hidden
  }
  originalSetAttribute.apply(this, arguments);
};

const root = ReactDOM.createRoot(rootElement);
root.render(
  <App />,
);
